var React = require('react');

function ArrowInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Path_329","data-name":"Path 329","d":"M10479.525,5904.892l2.427,2.488,3.308,3.39,2.569-2.668,2.755-2.861","transform":"translate(-10478.094 -5903.495)","fill":"none","stroke":"currentColor","strokeWidth":"4"}));
}

ArrowInline.defaultProps = {"width":"13.931","height":"10.148","viewBox":"0 0 13.931 10.148"};

module.exports = ArrowInline;

ArrowInline.default = ArrowInline;
